var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcerage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17678 1.82322C2.07915 1.72559 1.92085 1.72559 1.82322 1.82322L0.232233 3.41421C0.134602 3.51184 0.134602 3.67014 0.232233 3.76777C0.329864 3.8654 0.488155 3.8654 0.585786 3.76777L2 2.35355L3.41421 3.76777C3.51184 3.8654 3.67014 3.8654 3.76777 3.76777C3.8654 3.67014 3.8654 3.51184 3.76777 3.41421L2.17678 1.82322ZM22.1768 22.1768C22.2744 22.0791 22.2744 21.9209 22.1768 21.8232L20.5858 20.2322C20.4882 20.1346 20.3299 20.1346 20.2322 20.2322C20.1346 20.3299 20.1346 20.4882 20.2322 20.5858L21.6464 22L20.2322 23.4142C20.1346 23.5118 20.1346 23.6701 20.2322 23.7678C20.3299 23.8654 20.4882 23.8654 20.5858 23.7678L22.1768 22.1768ZM2 21.5H2.25V2H2H1.75V21.5H2ZM2.5 22V22.25H22V22V21.75H2.5V22ZM2 21.5H1.75C1.75 21.9142 2.08579 22.25 2.5 22.25V22V21.75C2.36193 21.75 2.25 21.6381 2.25 21.5H2Z",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H21.5C21.7761 2 22 2.22386 22 2.5V20",
    strokeDasharray: "1 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L20 4",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20L20 8",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20L20 12",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20L20 16",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16L16 4",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12L12 4",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8L8 4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcerage);
export default __webpack_public_path__ + "static/media/Acerage.9bc4e6cae806ea5d707f4524dc3e8a2f.svg";
export { ForwardRef as ReactComponent };